import { Form, Analytics } from 'tortilla';

export default {
  data: () => ({
    form: new Form(Tortilla.Xhr),
    showForm: true,
    successMessage: '',
    errorMessage: null,
    analytics: false,
    ga: null,
    clicky: null,
    clickyOptions: {
      name: 'Form Submission',
      goal: null,
      email: ''
    },
    // attributes that persist to the component after a form is submitted
    persistents: {},
    fields: {},
    recaptchaKey: window.googleRecaptchaKey
  }),
  computed: {
    hasErrors () {
      return !!this.errorMessage;
    },
    formErrors () {
      return this.form.errors.bag;
    }
  },
  watch: {
    formErrors (message) {
      this.$validator.errors.clear();
      for (let [key, message] of Object.entries(message)) {
        this.$validator.errors.add({ field: key, msg: message[0] });
      }

      this.errorMessage = this.getGlobalErrorMessage();
    }
  },
  beforeDestroy () {
    this.$eventsBus.$off('ready', this.init);
  },
  methods: {
    boot () {
      this.$eventsBus.$on('ready', this.init);
    },
    init () {
      try {
        this.ga = new Analytics.GoogleAnalytics();
      } catch (error) {
        console.error(error);
      }

      try {
        this.clicky = new Analytics.ClickyAnalytics();
      } catch (error) {
        console.error(error);
      }
    },
    getGlobalErrorMessage () {
      if (this.form.errors.has('message')) {
        return this.form.errors.first('message');
      }

      return this.form.errors.first('_global');
    },
    toggleForm () {
      this.showForm ^= 1;
    },
    success (response, event) {
      this.successMessage = this.form.success.first('message');
      this.reset();
      this.toggleForm();
      this.fireAnalytics();
      this.next(event);
    },
    fireAnalytics (event) {
      const uri = event.target.action;
      if (!(uri || this.analytics)) {
        return;
      }
      if (this.ga) {
        this.ga.sendGoal(uri);
      }
      if (this.clicky) {
        this.clicky.sendGoal(
          uri,
          this.clickyOptions.name,
          this.clickyOptions.goal,
          this.clickyOptions.email || ''
        );
      }
    },
    reset () {
      this.fields = {};
      this.errorMessage = '';
      this.$validator.errors.clear();
      this.$eventsBus.$emit('recaptcha-reset');
    },
    failure () {
      this.toggleForm();
      this.$eventsBus.$emit('recaptcha-reset');
    },
    beforeSubmit () {
      this.successMessage = '';
      this.toggleForm();
      this.fields.guid = window.getLassoGuid();
    },
    next (response) {
      if (typeof response === 'undefined') {
        return null;
      }
      if ('redirectTo' in response.data) {
        window.location = response.data.redirectTo;
      }
    },
    handleRecaptchaResponse (response) {
      if (response) {
        this.fields['g-recaptcha-response'] = response;
      }
    },
    recaptchaSubmit () {
      let grecaptchaPromise = new Promise((resolve, reject) => {
          resolve('grecaptcha is not yet available. submitting anyway.');
      });

      if (typeof grecaptcha !== 'undefined') {
          grecaptchaPromise = grecaptcha.execute(googleRecaptchaKey, { action: 'submit' }).then((token) => this.handleRecaptchaResponse(token));
      }

      return grecaptchaPromise;
  },
  }
};
